// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file vision/billing/v1/billing_service.proto (package protos.vision.billing.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { StartSubscriptionCheckoutRequestSchema, StartSubscriptionCheckoutResponseSchema } from "./start_subscription_checkout_pb";
import { file_vision_billing_v1_start_subscription_checkout } from "./start_subscription_checkout_pb";
import type { GetSubscriptionStatusRequestSchema, GetSubscriptionStatusResponseSchema } from "./get_subscription_status_pb";
import { file_vision_billing_v1_get_subscription_status } from "./get_subscription_status_pb";
import type { ListSubscriptionPlansRequestSchema, ListSubscriptionPlansResponseSchema } from "./list_subscription_plans_pb";
import { file_vision_billing_v1_list_subscription_plans } from "./list_subscription_plans_pb";
import type { ListCreditPacksRequestSchema, ListCreditPacksResponseSchema } from "./list_credit_packs_pb";
import { file_vision_billing_v1_list_credit_packs } from "./list_credit_packs_pb";
import type { StartCreditPackPurchaseRequestSchema, StartCreditPackPurchaseResponseSchema } from "./start_credit_pack_purchase_pb";
import { file_vision_billing_v1_start_credit_pack_purchase } from "./start_credit_pack_purchase_pb";
import type { StartProjectCreditPackPurchaseRequestSchema, StartProjectCreditPackPurchaseResponseSchema } from "./start_project_credit_pack_purchase_pb";
import { file_vision_billing_v1_start_project_credit_pack_purchase } from "./start_project_credit_pack_purchase_pb";
import type { TransferCreditsToProjectRequestSchema, TransferCreditsToProjectResponseSchema } from "./transfer_credits_to_project_pb";
import { file_vision_billing_v1_transfer_credits_to_project } from "./transfer_credits_to_project_pb";
import type { RetrieveProjectCreditsRequestSchema, RetrieveProjectCreditsResponseSchema } from "./retrieve_project_credits_pb";
import { file_vision_billing_v1_retrieve_project_credits } from "./retrieve_project_credits_pb";
import type { ListCreditTransactionsRequestSchema, ListCreditTransactionsResponseSchema } from "./list_credit_transactions_pb";
import { file_vision_billing_v1_list_credit_transactions } from "./list_credit_transactions_pb";
import type { ChangePlanRequestSchema, ChangePlanResponseSchema } from "./change_plan_pb";
import { file_vision_billing_v1_change_plan } from "./change_plan_pb";
import type { CancelScheduledPlanChangeRequestSchema, CancelScheduledPlanChangeResponseSchema } from "./cancel_scheduled_plan_change_pb";
import { file_vision_billing_v1_cancel_scheduled_plan_change } from "./cancel_scheduled_plan_change_pb";
import type { CancelSubscriptionRequestSchema, CancelSubscriptionResponseSchema } from "./cancel_subscription_pb";
import { file_vision_billing_v1_cancel_subscription } from "./cancel_subscription_pb";
import type { CreateBillingPortalSessionRequestSchema, CreateBillingPortalSessionResponseSchema } from "./create_billing_portal_session_pb";
import { file_vision_billing_v1_create_billing_portal_session } from "./create_billing_portal_session_pb";
import type { GetStorageBreakdownRequestSchema, GetStorageBreakdownResponseSchema } from "./get_storage_breakdown_pb";
import { file_vision_billing_v1_get_storage_breakdown } from "./get_storage_breakdown_pb";
import type { RecalculateStorageUsageRequestSchema, RecalculateStorageUsageResponseSchema } from "./recalculate_storage_usage_pb";
import { file_vision_billing_v1_recalculate_storage_usage } from "./recalculate_storage_usage_pb";

/**
 * Describes the file vision/billing/v1/billing_service.proto.
 */
export const file_vision_billing_v1_billing_service: GenFile = /*@__PURE__*/
  fileDesc("Cid2aXNpb24vYmlsbGluZy92MS9iaWxsaW5nX3NlcnZpY2UucHJvdG8SGHByb3Rvcy52aXNpb24uYmlsbGluZy52MTLrEAoNVmlzaW9uQmlsbGluZxKWAQoZU3RhcnRTdWJzY3JpcHRpb25DaGVja291dBI6LnByb3Rvcy52aXNpb24uYmlsbGluZy52MS5TdGFydFN1YnNjcmlwdGlvbkNoZWNrb3V0UmVxdWVzdBo7LnByb3Rvcy52aXNpb24uYmlsbGluZy52MS5TdGFydFN1YnNjcmlwdGlvbkNoZWNrb3V0UmVzcG9uc2UiABKKAQoVR2V0U3Vic2NyaXB0aW9uU3RhdHVzEjYucHJvdG9zLnZpc2lvbi5iaWxsaW5nLnYxLkdldFN1YnNjcmlwdGlvblN0YXR1c1JlcXVlc3QaNy5wcm90b3MudmlzaW9uLmJpbGxpbmcudjEuR2V0U3Vic2NyaXB0aW9uU3RhdHVzUmVzcG9uc2UiABKKAQoVTGlzdFN1YnNjcmlwdGlvblBsYW5zEjYucHJvdG9zLnZpc2lvbi5iaWxsaW5nLnYxLkxpc3RTdWJzY3JpcHRpb25QbGFuc1JlcXVlc3QaNy5wcm90b3MudmlzaW9uLmJpbGxpbmcudjEuTGlzdFN1YnNjcmlwdGlvblBsYW5zUmVzcG9uc2UiABJ4Cg9MaXN0Q3JlZGl0UGFja3MSMC5wcm90b3MudmlzaW9uLmJpbGxpbmcudjEuTGlzdENyZWRpdFBhY2tzUmVxdWVzdBoxLnByb3Rvcy52aXNpb24uYmlsbGluZy52MS5MaXN0Q3JlZGl0UGFja3NSZXNwb25zZSIAEpABChdTdGFydENyZWRpdFBhY2tQdXJjaGFzZRI4LnByb3Rvcy52aXNpb24uYmlsbGluZy52MS5TdGFydENyZWRpdFBhY2tQdXJjaGFzZVJlcXVlc3QaOS5wcm90b3MudmlzaW9uLmJpbGxpbmcudjEuU3RhcnRDcmVkaXRQYWNrUHVyY2hhc2VSZXNwb25zZSIAEqUBCh5TdGFydFByb2plY3RDcmVkaXRQYWNrUHVyY2hhc2USPy5wcm90b3MudmlzaW9uLmJpbGxpbmcudjEuU3RhcnRQcm9qZWN0Q3JlZGl0UGFja1B1cmNoYXNlUmVxdWVzdBpALnByb3Rvcy52aXNpb24uYmlsbGluZy52MS5TdGFydFByb2plY3RDcmVkaXRQYWNrUHVyY2hhc2VSZXNwb25zZSIAEpMBChhUcmFuc2ZlckNyZWRpdHNUb1Byb2plY3QSOS5wcm90b3MudmlzaW9uLmJpbGxpbmcudjEuVHJhbnNmZXJDcmVkaXRzVG9Qcm9qZWN0UmVxdWVzdBo6LnByb3Rvcy52aXNpb24uYmlsbGluZy52MS5UcmFuc2ZlckNyZWRpdHNUb1Byb2plY3RSZXNwb25zZSIAEo0BChZSZXRyaWV2ZVByb2plY3RDcmVkaXRzEjcucHJvdG9zLnZpc2lvbi5iaWxsaW5nLnYxLlJldHJpZXZlUHJvamVjdENyZWRpdHNSZXF1ZXN0GjgucHJvdG9zLnZpc2lvbi5iaWxsaW5nLnYxLlJldHJpZXZlUHJvamVjdENyZWRpdHNSZXNwb25zZSIAEo0BChZMaXN0Q3JlZGl0VHJhbnNhY3Rpb25zEjcucHJvdG9zLnZpc2lvbi5iaWxsaW5nLnYxLkxpc3RDcmVkaXRUcmFuc2FjdGlvbnNSZXF1ZXN0GjgucHJvdG9zLnZpc2lvbi5iaWxsaW5nLnYxLkxpc3RDcmVkaXRUcmFuc2FjdGlvbnNSZXNwb25zZSIAEmkKCkNoYW5nZVBsYW4SKy5wcm90b3MudmlzaW9uLmJpbGxpbmcudjEuQ2hhbmdlUGxhblJlcXVlc3QaLC5wcm90b3MudmlzaW9uLmJpbGxpbmcudjEuQ2hhbmdlUGxhblJlc3BvbnNlIgASlgEKGUNhbmNlbFNjaGVkdWxlZFBsYW5DaGFuZ2USOi5wcm90b3MudmlzaW9uLmJpbGxpbmcudjEuQ2FuY2VsU2NoZWR1bGVkUGxhbkNoYW5nZVJlcXVlc3QaOy5wcm90b3MudmlzaW9uLmJpbGxpbmcudjEuQ2FuY2VsU2NoZWR1bGVkUGxhbkNoYW5nZVJlc3BvbnNlIgASgQEKEkNhbmNlbFN1YnNjcmlwdGlvbhIzLnByb3Rvcy52aXNpb24uYmlsbGluZy52MS5DYW5jZWxTdWJzY3JpcHRpb25SZXF1ZXN0GjQucHJvdG9zLnZpc2lvbi5iaWxsaW5nLnYxLkNhbmNlbFN1YnNjcmlwdGlvblJlc3BvbnNlIgASmQEKGkNyZWF0ZUJpbGxpbmdQb3J0YWxTZXNzaW9uEjsucHJvdG9zLnZpc2lvbi5iaWxsaW5nLnYxLkNyZWF0ZUJpbGxpbmdQb3J0YWxTZXNzaW9uUmVxdWVzdBo8LnByb3Rvcy52aXNpb24uYmlsbGluZy52MS5DcmVhdGVCaWxsaW5nUG9ydGFsU2Vzc2lvblJlc3BvbnNlIgAShAEKE0dldFN0b3JhZ2VCcmVha2Rvd24SNC5wcm90b3MudmlzaW9uLmJpbGxpbmcudjEuR2V0U3RvcmFnZUJyZWFrZG93blJlcXVlc3QaNS5wcm90b3MudmlzaW9uLmJpbGxpbmcudjEuR2V0U3RvcmFnZUJyZWFrZG93blJlc3BvbnNlIgASkAEKF1JlY2FsY3VsYXRlU3RvcmFnZVVzYWdlEjgucHJvdG9zLnZpc2lvbi5iaWxsaW5nLnYxLlJlY2FsY3VsYXRlU3RvcmFnZVVzYWdlUmVxdWVzdBo5LnByb3Rvcy52aXNpb24uYmlsbGluZy52MS5SZWNhbGN1bGF0ZVN0b3JhZ2VVc2FnZVJlc3BvbnNlIgBiBnByb3RvMw", [file_vision_billing_v1_start_subscription_checkout, file_vision_billing_v1_get_subscription_status, file_vision_billing_v1_list_subscription_plans, file_vision_billing_v1_list_credit_packs, file_vision_billing_v1_start_credit_pack_purchase, file_vision_billing_v1_start_project_credit_pack_purchase, file_vision_billing_v1_transfer_credits_to_project, file_vision_billing_v1_retrieve_project_credits, file_vision_billing_v1_list_credit_transactions, file_vision_billing_v1_change_plan, file_vision_billing_v1_cancel_scheduled_plan_change, file_vision_billing_v1_cancel_subscription, file_vision_billing_v1_create_billing_portal_session, file_vision_billing_v1_get_storage_breakdown, file_vision_billing_v1_recalculate_storage_usage]);

/**
 * @generated from service protos.vision.billing.v1.VisionBilling
 */
export const VisionBilling: GenService<{
  /**
   * @generated from rpc protos.vision.billing.v1.VisionBilling.StartSubscriptionCheckout
   */
  startSubscriptionCheckout: {
    methodKind: "unary";
    input: typeof StartSubscriptionCheckoutRequestSchema;
    output: typeof StartSubscriptionCheckoutResponseSchema;
  },
  /**
   * @generated from rpc protos.vision.billing.v1.VisionBilling.GetSubscriptionStatus
   */
  getSubscriptionStatus: {
    methodKind: "unary";
    input: typeof GetSubscriptionStatusRequestSchema;
    output: typeof GetSubscriptionStatusResponseSchema;
  },
  /**
   * @generated from rpc protos.vision.billing.v1.VisionBilling.ListSubscriptionPlans
   */
  listSubscriptionPlans: {
    methodKind: "unary";
    input: typeof ListSubscriptionPlansRequestSchema;
    output: typeof ListSubscriptionPlansResponseSchema;
  },
  /**
   * @generated from rpc protos.vision.billing.v1.VisionBilling.ListCreditPacks
   */
  listCreditPacks: {
    methodKind: "unary";
    input: typeof ListCreditPacksRequestSchema;
    output: typeof ListCreditPacksResponseSchema;
  },
  /**
   * @generated from rpc protos.vision.billing.v1.VisionBilling.StartCreditPackPurchase
   */
  startCreditPackPurchase: {
    methodKind: "unary";
    input: typeof StartCreditPackPurchaseRequestSchema;
    output: typeof StartCreditPackPurchaseResponseSchema;
  },
  /**
   * @generated from rpc protos.vision.billing.v1.VisionBilling.StartProjectCreditPackPurchase
   */
  startProjectCreditPackPurchase: {
    methodKind: "unary";
    input: typeof StartProjectCreditPackPurchaseRequestSchema;
    output: typeof StartProjectCreditPackPurchaseResponseSchema;
  },
  /**
   * @generated from rpc protos.vision.billing.v1.VisionBilling.TransferCreditsToProject
   */
  transferCreditsToProject: {
    methodKind: "unary";
    input: typeof TransferCreditsToProjectRequestSchema;
    output: typeof TransferCreditsToProjectResponseSchema;
  },
  /**
   * @generated from rpc protos.vision.billing.v1.VisionBilling.RetrieveProjectCredits
   */
  retrieveProjectCredits: {
    methodKind: "unary";
    input: typeof RetrieveProjectCreditsRequestSchema;
    output: typeof RetrieveProjectCreditsResponseSchema;
  },
  /**
   * @generated from rpc protos.vision.billing.v1.VisionBilling.ListCreditTransactions
   */
  listCreditTransactions: {
    methodKind: "unary";
    input: typeof ListCreditTransactionsRequestSchema;
    output: typeof ListCreditTransactionsResponseSchema;
  },
  /**
   * @generated from rpc protos.vision.billing.v1.VisionBilling.ChangePlan
   */
  changePlan: {
    methodKind: "unary";
    input: typeof ChangePlanRequestSchema;
    output: typeof ChangePlanResponseSchema;
  },
  /**
   * @generated from rpc protos.vision.billing.v1.VisionBilling.CancelScheduledPlanChange
   */
  cancelScheduledPlanChange: {
    methodKind: "unary";
    input: typeof CancelScheduledPlanChangeRequestSchema;
    output: typeof CancelScheduledPlanChangeResponseSchema;
  },
  /**
   * @generated from rpc protos.vision.billing.v1.VisionBilling.CancelSubscription
   */
  cancelSubscription: {
    methodKind: "unary";
    input: typeof CancelSubscriptionRequestSchema;
    output: typeof CancelSubscriptionResponseSchema;
  },
  /**
   * @generated from rpc protos.vision.billing.v1.VisionBilling.CreateBillingPortalSession
   */
  createBillingPortalSession: {
    methodKind: "unary";
    input: typeof CreateBillingPortalSessionRequestSchema;
    output: typeof CreateBillingPortalSessionResponseSchema;
  },
  /**
   * @generated from rpc protos.vision.billing.v1.VisionBilling.GetStorageBreakdown
   */
  getStorageBreakdown: {
    methodKind: "unary";
    input: typeof GetStorageBreakdownRequestSchema;
    output: typeof GetStorageBreakdownResponseSchema;
  },
  /**
   * @generated from rpc protos.vision.billing.v1.VisionBilling.RecalculateStorageUsage
   */
  recalculateStorageUsage: {
    methodKind: "unary";
    input: typeof RecalculateStorageUsageRequestSchema;
    output: typeof RecalculateStorageUsageResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_vision_billing_v1_billing_service, 0);

